import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api, { apiError, setToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AuthShell } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { PasswordInput } from "@/components/PasswordInput";
import { CircleNotch } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function AcceptInvite() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const token = params.get("token") || "";
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) { setError("Convite inválido."); return; }
    api.get(`/auth/invite/${token}`).then((r) => setInfo(r.data))
      .catch((err) => setError(apiError(err, "Convite inválido ou expirado.")));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/accept-invite", { token, password });
      if (data.access_token) setToken(data.access_token);
      await refresh();
      toast.success("Bem-vindo(a) à equipa!");
      navigate("/");
    } catch (err) {
      toast.error(apiError(err));
    } finally { setBusy(false); }
  };

  return (
    <AuthShell title="Aceitar convite" subtitle={info ? `Junte-se a ${info.organization}` : "A carregar convite…"}>
      {error ? (
        <div className="space-y-4" data-testid="invite-error">
          <div className="rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-700">{error}</div>
          <Link to="/login" className="text-sm font-medium text-primary hover:underline">Ir para o início de sessão</Link>
        </div>
      ) : !info ? (
        <div className="flex h-24 items-center"><CircleNotch size={24} className="animate-spin text-primary" /></div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="accept-invite-form">
          <div className="rounded-lg border border-border bg-secondary/40 p-3 text-sm">
            <div className="font-medium">{info.name}</div>
            <div className="text-muted-foreground">{info.email}</div>
          </div>
          <div className="space-y-1.5">
            <Label>Defina a sua palavra-passe</Label>
            <PasswordInput required minLength={6} value={password}
              onChange={(e) => setPassword(e.target.value)} testid="invite-password" placeholder="Mínimo 6 caracteres" />
          </div>
          <Button type="submit" className="w-full rounded-full" disabled={busy} data-testid="accept-invite-submit">
            {busy ? <CircleNotch className="animate-spin" /> : "Entrar na equipa"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
